<script setup lang="ts">
import AppHeader from '@/components/shared/AppHeader.vue'
import AppFooter from '@/components/shared/AppFooter.vue'
</script>

<template>
  <div class="flex min-h-dvh flex-col bg-background text-foreground">
    <AppHeader />
    <main class="min-w-0 flex-1">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>



